export const attendanceCycle = (year: number, month: number) => {
  const previousMonth = month === 1 ? 12 : month - 1;
  const previousYear = month === 1 ? year - 1 : year;
  return {
    startDate: `${previousYear}-${String(previousMonth).padStart(2, "0")}-26`,
    endDate: `${year}-${String(month).padStart(2, "0")}-25`,
  };
};
